import axios from 'axios';
import InsurancesPageEntity from './insurances-page-entity';
import PendingRequestEntity from '../entities/pending-request-entity';

class InsurancesPageService {

  hydrate (data) {
    return new InsurancesPageEntity(
      data.id,
      data.title.rendered,
      data.acf.insurances_ingress,
      data.acf.insurances_text,
      data.acf.insurances_sections,
      data.acf.insurances_image.url,
      data.acf.insurances_letter_button,
      data.acf.insurances_letter_box
    );
  }

  get (pageID) {
    let pendingRequest = new PendingRequestEntity();

    pendingRequest.promise = axios.get('https://www.frilansfinans.se/wp-json/wp/v2/pages/' + pageID, {
      cancelToken: new axios.CancelToken(function executor (c) {
        pendingRequest.cancel = c;
      })
    })
    .then((response) => this.hydrate(response.data));

    return pendingRequest;
  }

}

export default new InsurancesPageService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/insurances-page/insurances-page-service.js
 **/